import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../axios.js';

import './Resources/dashboard.css';


function Add_vendor(){

  
  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");

 
//saving default values with usestate
const state = useState();

//vendor_name
const[vendor_name,setvendor_name]=useState();const updatevendor_name = (event) => { setvendor_name(event.target.value);}; const[vendor_name_er,setvendor_name_er]=useState();
//email
const[email,setemail]=useState();const updateemail = (event) => { setemail(event.target.value);}; const[email_er,setemail_er]=useState();
//contact
const[contact,setcontact]=useState();const updatecontact = (event) => { setcontact(event.target.value);}; const[contact_er,setcontact_er]=useState();
//trade_name
const[trade_name,settrade_name]=useState();const updatetrade_name = (event) => { settrade_name(event.target.value);}; const[trade_name_er,settrade_name_er]=useState();
//address
const[address,setaddress]=useState();const updateaddress = (event) => { setaddress(event.target.value);}; const[address_er,setaddress_er]=useState();
//city
const[city,setcity]=useState();const updatecity = (event) => { setcity(event.target.value);}; const[city_er,setcity_er]=useState();
//cstate
const[cstate,setcstate]=useState();const updatecstate = (event) => { setcstate(event.target.value);}; const[cstate_er,setcstate_er]=useState();
//country
const[country,setcountry]=useState();const updatecountry = (event) => { setcountry(event.target.value);}; const[country_er,setcountry_er]=useState();
//pincode
const[pincode,setpincode]=useState();const updatepincode = (event) => { setpincode(event.target.value);}; const[pincode_er,setpincode_er]=useState();
//type
const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
//category
const[category,setcategory]=useState();const updatecategory = (event) => { setcategory(event.target.value);}; const[category_er,setcategory_er]=useState();
//gstin
const[gstin,setgstin]=useState();const updategstin = (e) => {const value = e.target.value.replace(/[^A-Z0-9]/gi, "").toUpperCase();setgstin(value);}; const[gstin_er,setgstin_er]=useState();
//license_no
const[license_no,setlicense_no]=useState();const updatelicense_no = (event) => { setlicense_no(event.target.value);}; const[license_no_er,setlicense_no_er]=useState();



//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




  
//******************* ADD VENDOR FUNCTION START ********************//
function addvendor(){

  //Setting Error Variables
setvendor_name_er(" ");setemail_er(" ");setcontact_er(" ");settrade_name_er(" ");setaddress_er(" ");setcity_er(" ");setcstate_er(" ");
setcountry_er(" ");setpincode_er(" "); settype_er(" ");setcategory_er(" ");setgstin_er(" ");setlicense_no_er(" ");seterror_msg(" ");



  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 
  axios.post("addvendor", {
   Log_id:logid,
   Token:token,
   Name : vendor_name,
   Email:email,
   Contact : contact,
   Trade_name:trade_name,
   Address:address,
   City:city,
   State:cstate,
   Country:country,
   Pincode:pincode,
   Type:type,
   Category:category,
   Gstin:gstin,
   License_no:license_no


  })
  .then((response) => {

  
  //Bank Limit Reached
  if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }


  else if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
 else if(response.data.validatorerror){
  setvendor_name_er(response.data.validatorerror.Vendor_name);
  setemail_er(response.data.validatorerror.Email);
  setcontact_er(response.data.validatorerror.Contact);
  settrade_name_er(response.data.validatorerror.Trade_name);
  setaddress_er(response.data.validatorerror.Address);
  setcity_er(response.data.validatorerror.City);
  setcstate_er(response.data.validatorerror.State);
  setcountry_er(response.data.validatorerror.Country);
  setpincode_er(response.data.validatorerror.Pincode);
  settype_er(response.data.validatorerror.Type);
  setcategory_er(response.data.validatorerror.Category);
  setgstin_er(response.data.validatorerror.Gstin);
  setlicense_no_er(response.data.validatorerror.License_no);
  seterror_msg("Cannot Add Vendor !"); 
}
//Invalid Entries
else if(response.data.error==102){ 
  
  setvendor_name_er(response.data.vendor_name_er);
  setemail_er(response.data.email_er);
  setcontact_er(response.data.contact_er);
  settrade_name_er(response.data.trade_name_er);
  setaddress_er(response.data.bank_address_er);
  setcity_er(response.data.city_er);
  setcstate_er(response.data.state_er);
  setcountry_er(response.data.country_er);
  setpincode_er(response.data.pincode_er);
  settype_er(response.data.type_er);
  setcategory_er(response.data.category_er);
  setgstin_er(response.data.gstin_er);
  setlicense_no_er(response.data.license_no_er);
  seterror_msg("Cannot Add Vendor !");  }


  //Invalid Entries
  else if(response.data.error==103){     seterror_msg(response.data.error_msg);  }

   //Transaction Entered Successfully
   else if(response.data.successvar==1){        document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Add Vendor !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* ADD VENDOR FUNCTION END ********************//


return(
    <>
                <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("create-form1").style.display="none"; }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Add Vendor</h4>
                    <div class="form-sample">
                      <p class="card-description">enter your vendor details here</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Vendor Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Manoj Kumar" id="vendor_name" value={vendor_name} onChange={updatevendor_name} />
                              <code>{vendor_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Vendor Type<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} placeholder="Select Vendor Type" id="type" value={type} onChange={updatetype}>
                              <option value="">Select vendor Type</option>
                              <option value="sole proprietorship">sole proprietorship</option>
                              <option value="private limited company">private limited company</option>
                              <option value="registered partnership">registered partnership</option>
                              <option value="unregistered partnership">unregistered partnership</option>
                              <option value="other">other</option>
                              </select>
                              <code>{type_er}</code>
                            </div>
                          </div>
                        </div>   
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Trade Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="ABC Private Limited" id="trade_name" value={trade_name} onChange={updatetrade_name} />
                             <code>{trade_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="email" class="form-control" placeholder="abccompany@gmail.com" id="email" value={email} onChange={updateemail} />
                             <code>{email_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                       <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="ABC Private Limited" id="contact" value={contact} onChange={updatecontact} />
                             <code>{contact_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Category</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="type category" id="category" value={category} onChange={updatecategory} />
                             <code>{category_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">GSTIN</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="AAJ1029229222" id="gstin" value={gstin} onChange={updategstin} autoCapitalize='on' maxLength={15} />
                             <code>{gstin_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">License No.</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="license_no" id="license_no" value={license_no} onChange={updatelicense_no} />
                             <code>{license_no_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Address</label>
                        <textarea  class="form-control"  rows="2" id="address" value={address} onChange={updateaddress}></textarea>
                      <code>{address_er}</code>
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">City</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Satna" id="city" value={city} onChange={updatecity} />
                             <code>{city_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">State</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Madhya Pradesh" id="cstate" value={cstate} onChange={updatecstate} />
                             <code>{cstate_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Country</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="India" id="country" value={country} onChange={updatecountry} />
                             <code>{country_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Pincode</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="pincode" id="pincode" value={pincode} onChange={updatepincode} />
                             <code>{pincode_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                 
                      <div class="row">
                        
                        <div class="col-md-6">
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={addvendor} >Add Vendor</button>
                        </div>                     
                      </div>

                                        
    
                     
                   
                    </div>
                  </div>
                </div>
    </>

);

}

export default Add_vendor;